import Swal from "sweetalert2";

export function handleError(error, context = "Erro na requisição") {
  // Sessão expirada/revogada já tem tratamento próprio e centralizado: o interceptor global
  // (services/api.js) dispara SESSAO_EXPIRADA_EVENT, e o AuthContext mostra um toast e faz logout.
  // Mostrar este modal também duplicaria a mensagem com um texto cru e feio ("Request failed with
  // status code 401") por cima do toast já exibido. Login com credencial errada também é 401, mas
  // esse caso PRECISA aparecer aqui — é a única forma de o usuário saber que digitou senha errada —
  // por isso a mesma exceção que o interceptor já usa (`isLoginRequest`).
  const isLoginRequest = error?.config?.url?.includes("/usuario/login");
  if (error?.response?.status === 401 && !isLoginRequest) return;

  let msg = context;

  if (error.response?.data?.error) {
    msg = error.response.data.error;
  } else if (error.message) {
    msg = `${context}: ${error.message}`;
  }

  // Exibir erro com SweetAlert2
  Swal.fire({
    title: "Erro",
    text: msg,
    icon: "error",
  });

  // Se no futuro você quiser mudar para um toast:
  // toast.error(msg); // Usando uma biblioteca de toasts, por exemplo.
}
